import { QuickInfoBadgeInfo } from '@aibees/elephant/feature/search-table-people/components/people-quick-info/types';
import type { IconName } from '@aibees/shared/components';
import type { SxStyle } from '@aibees/shared/theme';
import { ButtonProps } from '@mui/material';
import type { ReactNode } from 'react';

export enum QUICK_INFO_BUTTONS {
  EMAIL_ENRICHMENT = 'EMAIL_ENRICHMENT',
  PHONENUMBER_ENRICHMENT = 'PHONENUMBER_ENRICHMENT',
  CONTACT_ENRICHMENT = 'CONTACT_ENRICHMENT',
  PERSONALITY_ANALYSIS = 'PERSONALITY_ANALYSIS',
}

export interface QuickInfoGroupItem<T = any> {
  id: QUICK_INFO_BUTTONS;
  icon: IconName;
  badge: (item: T) => QuickInfoBadgeInfo;
  title?: (item: T) => ReactNode;
  iconSx?: SxStyle;
  iconSize?: number;
  disabled?: ((item: T) => boolean) | boolean;
  tooltipText?: string;
  hideBadge?: (item: T) => boolean;
}

export interface QuickInfoButtonProps<T = any> extends QuickInfoGroupItem<T> {
  buttonProps?: Omit<ButtonProps, 'onClick' | 'disabled' | 'children'>;
  className?: string;
  data: T;
  onSelect: (target: HTMLElement, item: T, id: QUICK_INFO_BUTTONS) => void;
}
